import { createContext } from 'react';
export const PleditorContext = createContext(null);
